import { render, staticRenderFns } from "./tipToast.vue?vue&type=template&id=19a08beb&scoped=true"
import script from "./tipToast.vue?vue&type=script&lang=js"
export * from "./tipToast.vue?vue&type=script&lang=js"
import style0 from "./tipToast.vue?vue&type=style&index=0&id=19a08beb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a08beb",
  null
  
)

export default component.exports